import Backbone from 'backbone'
import template from './license-panel.hbs'
import i18n from 'scoreboard/components/i18n'
import LicensedDatabase from './licensed-database'
import _ from 'lodash'
import LicenseForm from './license-form'
import appDisplay from 'scoreboard/components/app-display'

const UNLIMITED = -1

var LicensePanel = Backbone.View.extend({

	// this.license is the license
	// this.options.unlinkedDatabases is an array of the unlinked databases

	className: 'license-panel',

	events: {
		'click .edit-license': 'editLicense'
	},

	initialize: function(options) {
		this.options = options || {}
		this.license = this.options.license
	},

	render: function() {
		this.$el.empty().append(template(this.options.license))

		// handle daysUntilExpiration
		if (this.license.daysUntilExpiration < 0) {
			this.$el.addClass('is-expired')
			this.$('.license-status').text(i18n.get('admin.licenseUsage.status.expired'))
		} else {
			var key = 'admin.licenses.expiresIn.' +
				(this.license.daysUntilExpiration === 1 ? 'singular' : 'plural')
			this.$('.license-status').text(i18n.get(key, this.license.daysUntilExpiration))
		}

		// handle usage message
		const {usage, databases, databasesExceeded} = this.license
		var dbUsageMessage = i18n.get('admin.licenses.usage',
			_.size(usage), databases === UNLIMITED ? i18n.get('admin.licenseUsage.unlimited') : databases)
		this.$('.database-usage-message').append(dbUsageMessage)
			.toggleClass('linkage-exceeded', databasesExceeded)
		this.$el.toggleClass('is-violated', databasesExceeded)

		// show the databases that use the license
		var panelContent = this.$('.panel-content')
		this.licensedDatabases = []
		_.each(this.license.usage, function(usage) {
			var licensedDatabase = new LicensedDatabase({
				license: this.license,
				usage: usage
			})
			if (usage.exceeded) {
				this.$el.addClass('is-violated')
			}
			this.licensedDatabases.push(licensedDatabase)
			panelContent.append(licensedDatabase.el)
			licensedDatabase.render()
		}.bind(this))

		return this
	},

	editLicense: function() {
		var licenseForm = new LicenseForm({
			license: this.license,
			unlinkedDatabases: this.options.unlinkedDatabases
		})
		appDisplay.dialog(licenseForm)
		// pass through all events to admin-licenses
		licenseForm.on('all', this.trigger.bind(this))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.licensedDatabases, 'remove')
	}

})

export default LicensePanel

LicensePanel.__filename__ = 'admin/licenses/license-panel.js'
